import React from 'react';
import { MyloAppbanner } from './styled';
import { downloadAppHandler } from '../../../Utils/redirections';

function GetMyloAppBanner(props) {
  return (
    <MyloAppbanner onClick={downloadAppHandler}>
      <img
        src="https://images.myloapp.in/NestJsUploads/1735550926226-Mweb_side_drawer_banner.webp"
        alt=""
      />
    </MyloAppbanner>
  );
}

export default GetMyloAppBanner;
